import React from "react";
import styles from "./DeleteIconButton.module.scss";
import Icon from "../Icon/Icon";
import Tooltip from "../Tooltip/Tooltip";
import { useAppSelector } from "../../../redux/hooks";
import { useTranslation } from "react-i18next";

export type DeleteIconButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  testId?: string;
  tooltipContentWhenDisabled?: React.ReactNode;
};

const DeleteIconButton: React.FC<DeleteIconButtonProps> = ({
  onClick,
  disabled = false,
  className = "",
  testId,
  tooltipContentWhenDisabled,
}) => {
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const { t } = useTranslation();

  const iconColor = currentTheme === "light" ? "#2C2C2C" : "#D8D8D9";

  const content = tooltipContentWhenDisabled ?? (
    <span className={styles.tooltip_title}>{t("access_restricted_to_creator")}</span>
  );

  const iconEl = (
    <div
      className={`${styles.delete_icon} ${disabled ? styles.disabled : ""} ${className}`}
      role="button"
      aria-disabled={disabled}
      data-testid={testId}
      onClick={!disabled ? onClick : undefined}
    >
      <Icon name="delete_icon" size={18} color={iconColor} />
    </div>
  );

  if (disabled) {
    return (
      <Tooltip content={content} width="180px" height="auto" bottom="33px" tipPos={true} className={styles.tooltip}>
        {iconEl}
      </Tooltip>
    );
  }

  return iconEl;
};

export default DeleteIconButton;